import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useBrand } from "@/brand/BrandProvider";
import { tx } from "@/components/ui";

/** Header + frame shared by the public pages (wizard, manage link, waitlist claim). */
export function PublicShell({ children, title }: { children: ReactNode; title?: string }) {
  const { t, i18n } = useTranslation();
  const brand = useBrand();
  const name = brand ? tx(brand.name, i18n.language) : t("app.title");
  return (
    <main className="min-h-screen p-4 flex justify-center">
      <div className="w-full max-w-xl space-y-4">
        <header className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            {brand?.logo_url ? <img src={brand.logo_url} alt={name} className="h-12 max-w-[160px] object-contain" /> : <span className="text-xl font-semibold text-accent">{name}</span>}
            {title && <span className="text-sm text-gray-500 hidden sm:inline">· {title}</span>}
          </div>
          <button className="text-xs underline" onClick={() => i18n.changeLanguage(i18n.language === "el" ? "en" : "el")}>{i18n.language === "el" ? "EN" : "EL"}</button>
        </header>
        {children}
      </div>
    </main>
  );
}

export function reasonText(t: (k: string, o?: Record<string, unknown>) => string, detail: string): string {
  try {
    const d = JSON.parse(detail);
    if (d && typeof d === "object" && "reason" in d) return t(`book.err.${d.reason}`, { defaultValue: t(`reason.${d.reason}`, { defaultValue: d.reason }) });
  } catch { /* plain string */ }
  return t(`book.err.${detail}`, { defaultValue: detail });
}
